import React from 'react';
export function TermsPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-752">
      <div className="max-w-4xl mx-auto px-6" data-id="element-753">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-754">
          Términos y Condiciones
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-755">
          <p className="text-sm text-[#8b6f6f]" data-id="element-756">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-757">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-758">
              1. Aceptación de los Términos
            </h2>
            <p data-id="element-759">
              Al acceder y utilizar este sitio web y adquirir nuestros productos
              digitales, usted acepta estar sujeto a estos Términos y
              Condiciones. Si no está de acuerdo con alguna parte de estos
              términos, no debe utilizar nuestros servicios.
            </p>
          </section>

          <section data-id="element-760">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-761">
              2. Descripción del Producto
            </h2>
            <p data-id="element-762">
              "El Divorcio Emocional" es un producto digital en formato PDF que
              incluye:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-763">
              <li data-id="element-764">Guía completa en formato PDF descargable</li>
              <li data-id="element-765">
                Bonus especial: "Microgestos Femeninos Que Reviven la Intimidad"
              </li>
              <li data-id="element-766">Acceso inmediato tras la compra</li>
              <li data-id="element-767">Compatible con todos los dispositivos</li>
            </ul>
          </section>

          <section data-id="element-768">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-769">
              3. Precio y Pago
            </h2>
            <p data-id="element-770">
              El precio del producto es de $12.99 USD. El pago se procesa de
              forma segura a través de Hotmart. Al completar la compra, usted
              acepta pagar el precio indicado más cualquier impuesto aplicable.
            </p>
          </section>

          <section data-id="element-771">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-772">
              4. Entrega del Producto
            </h2>
            <p data-id="element-773">
              Tras la confirmación del pago, recibirá acceso inmediato al
              producto digital a través del correo electrónico proporcionado
              durante la compra. Es su responsabilidad proporcionar una
              dirección de correo electrónico válida.
            </p>
          </section>

          <section data-id="element-774">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-775">
              5. Propiedad Intelectual
            </h2>
            <p data-id="element-776">
              Todo el contenido incluido en "El Divorcio Emocional" está
              protegido por derechos de autor. Usted recibe una licencia
              personal, no transferible, para usar el material. Está prohibido:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-777">
              <li data-id="element-778">Reproducir, distribuir o vender el contenido</li>
              <li data-id="element-779">Compartir el material con terceros</li>
              <li data-id="element-780">Modificar o crear obras derivadas</li>
              <li data-id="element-781">Usar el contenido con fines comerciales</li>
            </ul>
          </section>

          <section data-id="element-782">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-783">
              6. Garantía de Satisfacción
            </h2>
            <p data-id="element-784">
              Ofrecemos una garantía de satisfacción de 30 días. Si no está
              satisfecho con su compra, puede solicitar un reembolso completo
              dentro de los 30 días posteriores a la compra. Consulte nuestra
              política de reembolsos para más detalles.
            </p>
          </section>

          <section data-id="element-785">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-786">
              7. Descargo de Responsabilidad
            </h2>
            <p data-id="element-787">
              El contenido proporcionado es solo para fines educativos e
              informativos. No constituye asesoramiento profesional en
              psicología, terapia de pareja o consejería matrimonial. Los
              resultados pueden variar según cada situación individual.
            </p>
          </section>

          <section data-id="element-788">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-789">
              8. Limitación de Responsabilidad
            </h2>
            <p data-id="element-790">
              En ningún caso seremos responsables por daños indirectos,
              incidentales, especiales o consecuentes que resulten del uso o la
              imposibilidad de usar nuestros productos.
            </p>
          </section>

          <section data-id="element-791">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-792">
              9. Modificaciones
            </h2>
            <p data-id="element-793">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>
          </section>

          <section data-id="element-794">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-795">
              10. Contacto
            </h2>
            <p data-id="element-796">
              Si tiene preguntas sobre estos Términos y Condiciones, puede
              contactarnos a través de nuestro correo electrónico de soporte.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30" data-id="element-797">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-798">
            ← Volver a la página principal
          </a>
        </div>
      </div>
    </div>;
}